import { FormRenderProps } from 'react-final-form';
import { useDispatch, useSelector } from 'react-redux';
import { useCallback, useEffect } from 'react';

import { IAdminSetting } from '../../../APIPackage/AdminModule/interfaces/IAdminSetting';
import { IDecisionForm } from '../interfaces/IDecisionForm';
import { IErknmStatusHintField } from '../../../KnmPackage/MainModule/interfaces/IErknmStatusHintField';
import { getDecisionFormRef, getKnmIsDecisionStatusFillInProcess } from '../selectors/decisionSelectors';
import { decisionSetStatusHintText, decisionSetStatusHintFields } from '../actions/decisionActions';
import { getDecisionErrorFieldDataByFlatName } from '../common/getDecisionErrorFieldDataByFlatName';
import { IDecisionFormRef } from '../interfaces/IDecisionFormRef';
import { isFieldsRequiredForDecisionCompleted } from '../common/fieldsRequiredForDecisionCompleted';

type FormRenderType = FormRenderProps<IDecisionForm>;

interface IUseDecisionFormStatusHintInitParams {
  values: IDecisionForm;
  touched: FormRenderType['touched'];
  settings: IAdminSetting[] | undefined;
}

const getEmptyMarkedFields = (
  markedFields: string[],
  formRef: IDecisionFormRef | undefined,
): IErknmStatusHintField[] => {
  const result: IErknmStatusHintField[] = [];
  const emptyMarkedFields = markedFields.filter(item => {
    const value = formRef?.current.getFieldState(item as keyof IDecisionForm)?.value;

    return !value || (Array.isArray(value) && !value.length);
  });

  emptyMarkedFields.forEach(item => {
    const fieldData = formRef ? getDecisionErrorFieldDataByFlatName(item, formRef) : undefined;

    if (fieldData?.title) {
      result.push({ scrollToId: fieldData.scrollElementId, title: fieldData.title, field: item });
    }
  });

  return result;
};

export function useDecisionFormStatusHintInit({ values, touched, settings }: IUseDecisionFormStatusHintInitParams) {
  const dispatch = useDispatch();
  const isStatusFillInProcess = useSelector(getKnmIsDecisionStatusFillInProcess);
  const formRef = useSelector(getDecisionFormRef);

  const updateDecisionStatusFillInProcessToCompleted = useCallback(() => {
    const markedFields = touched
      ? Object.keys(touched).filter(item => isFieldsRequiredForDecisionCompleted(item, values))
      : [];

    const emptyMarkedFields = getEmptyMarkedFields(markedFields, formRef);

    const text = emptyMarkedFields.length
      ? `Для перехода в статус “Завершено” необходимо заполнить указанные сведения и подписать паспорт:`
      : `Для перехода в статус “Завершено” необходимо подписать паспорт`;

    dispatch(decisionSetStatusHintText(text));
    dispatch(decisionSetStatusHintFields(emptyMarkedFields));
  }, [values, touched, formRef, settings]);

  useEffect(() => {
    if (isStatusFillInProcess) {
      updateDecisionStatusFillInProcessToCompleted();
    } else {
      dispatch(decisionSetStatusHintText(undefined));
      dispatch(decisionSetStatusHintFields([]));
    }
  }, [isStatusFillInProcess, updateDecisionStatusFillInProcessToCompleted]);
}
